import { Button, Layout, message, Modal, Space, Table, Tabs } from 'antd';
import { Content } from 'antd/es/layout/layout';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getUsers } from '../../redux/actions/AllActions';
import Filter from '../../components/Filter/Filter';
import Loading from '../../components/Loading/Loading';
import TabPane from 'antd/es/tabs/TabPane';
import AddUser from '../Add/AddUser/AddUser';
import EditUser from '../Edit/EditUser/EditUser';
import { deleteUser } from '../../api/user';
import UserDetails from '../Details/UserDetails';


const Users = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { data, loading } = useSelector((state) => state.data);
  const [showAddModel, setShowAddModel] = useState(false);

  const [filteredItems, setFilteredItems] = useState([]);
  const [isEditingModelVisible, setIsEditingModelVisible] = useState(false);
  const [isCreateModelVisible, setIsCreateModelVisible] = useState(false);
  const [handleDetailsVisible, setHandleDetailsVisible] = useState(false);
  const [editingRecord, setEditingRecord] = useState(null);

  const [activeKey, setActiveKey] = useState('1')
  const handleChange = (key) => {
    setActiveKey(key);
  }


  const [admin, setAdmin] = useState("");

  useEffect(() => {
    const adminData = localStorage.getItem("admindata");
    try {
      const parsedData = JSON.parse(adminData);
      if (parsedData && typeof parsedData === "object") {
        setAdmin(parsedData);
      } else {
        console.error("Invalid admin data structure");
        localStorage.removeItem("admindata");
      }
    } catch (error) {
      console.error("Error parsing admin data:", error);
      localStorage.removeItem("admindata");
    }
  }, []);


  useEffect(() => {
    setFilteredItems(data);
  }, [data]);
  const fetch = () => {
    dispatch(getUsers());

  }
  // Fetch users on component mount
  useEffect(() => {
    fetch()
  }, [dispatch]);

  const handleEdit = (record) => {
    setEditingRecord(record);
    setIsEditingModelVisible(true);
  };

  const handleDelete = (record) => {
   
    Modal.confirm({
      title: 'Are you sure you want to delete this user?',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk: async () => {
        try {
          const resp = await (deleteUser(record._id));
          if (resp) {
            dispatch(getUsers());
            message.success('User deleted successfully.');
          } else {
            message.error('Failed to delete user');
          }
        } catch (error) {
          message.error('An error occurred while deleting the user');
        }
      },
    });



  };

  const handleDetails = (record) => {
    setEditingRecord(record);
    setHandleDetailsVisible(true);
  };

  const handleEditCancel = () => {
    setIsEditingModelVisible(false);
  };

  const columns = [
    {
      title: 'First Name',
      dataIndex: 'name',
      key: 'name',
      width: 300,
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'name',
      width: 300,
    },
    {
      title: 'Type of User',
      dataIndex: 'designation',
      key: 'designation',
      width: 300,
    },
    {
      title: 'Business Name',
      dataIndex: 'businessName',
      key: 'businessName',
      width: 300,
    },
    {
      title: 'Gst Number',
      dataIndex: 'gstNumber',
      key: 'gstNumber',
      width: 300,
    },
    {
      title: 'Entry Type',
      dataIndex: 'entryType',
      key: 'entryType',
      width: 300,
    },
    {
      title: 'Industry Type',
      dataIndex: 'industryType',
      key: 'industryType',
      width: 300,
    },
    {
      title: 'Business Address',
      dataIndex: 'businessAddress',
      key: 'businessAddress',
      width: 300,
    },
    {
      title: 'Business Overview',
      dataIndex: 'businessOverview',
      key: 'businessOverview',
      width: 300,
    },

    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Space>

          {
            // admin?.role === 'superAdmin' &&
            <div
              style={{
                display: 'flex',
                width: "200px"
              }}
            >
              <Button type="link" onClick={() => handleEdit(record)}>
                Edit
              </Button>
              <Button type="link" onClick={() => handleDetails(record)}>
                Details
              </Button>
              <Button type="link" danger onClick={() => handleDelete(record)}>
                Delete
              </Button>

            </div>
          }     </Space>
      ),
      fixed: 'right'
    },
  ];
  return (
    <Layout
    
      style={{
       
        height: "82vh",
    }}
    >
      <Button
        style={{
          width: "100px"
        }}
        onClick={() => setShowAddModel(true)}
      >+ Add User</Button>
      {
        loading ?
          <Loading /> :
          <>
            <Filter
              allData={data}
              setFilteredItems={setFilteredItems}
              searchKeys={['name', 'email', 'businessOverview']}
            />
            <Content
             
            >
              <div style={{ overflowX: 'auto', width: '100%' }}>
                <Tabs
                  activeKey={activeKey}
                  onChange={handleChange}
                >
                  <TabPane
                    tab={"User"}
                    key="1"
                  >
                    <Table
                      
                      columns={columns}
                      pagination={{ position: ['bottomCenter'], pageSize: 10 }}
                      dataSource={filteredItems?.filter((item) => item?.designation !== 'Agent')}
                      rowKey={(record) => record._id}
                      style={{ height: '68vh' }}

                      scroll={{ x: 'max-content', y: 'calc(100vh - 300px)' }}
                    />
                  </TabPane>
                  <TabPane
                    tab="Agent"
                    key="2"
                  >
                    <Table
                      columns={columns}
                      pagination={{ position: ['bottomCenter'], pageSize: 10 }}
                      dataSource={filteredItems?.filter((item) => item?.designation === 'Agent')}
                      rowKey={(record) => record._id} style={{ height: '68vh' }}
                      scroll={{ x: 'max-content', y: 'calc(100vh - 300px)' }}
                    />
                  </TabPane>
                </Tabs>
              </div>
            </Content>
            <Modal
              title="Add Modal"
              open={showAddModel}
              onCancel={() => setShowAddModel(false)}
              footer={null}
            >
              <AddUser
                setShowAddModel={setShowAddModel}
              />
            </Modal>
            {/* Edit User Modal */}
            <Modal
              title="Edit User"
              open={isEditingModelVisible}
              onCancel={handleEditCancel}
              footer={null}
            >
              <EditUser
                user={editingRecord}
                handleEditCancel={handleEditCancel}
                
              />
            </Modal>

            {/* Details Modal */}
            <Modal
              title="User Details"
              open={handleDetailsVisible}
              onCancel={() => setHandleDetailsVisible(false)}
              footer={null}
            >
              <UserDetails
              user = {editingRecord}
              />
            </Modal>
          </>
      }
    </Layout>
  );
};

export default Users;
